
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma

/**
 * Prisma Client JS version: 3.15.1
 * Query Engine version: b71d8cb16c4ddc7e3e9821f42fd09b0f82d7934c
 */
Prisma.prismaVersion = {
  client: "3.15.1",
  engine: "b71d8cb16c4ddc7e3e9821f42fd09b0f82d7934c"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = () => (val) => val

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = 'DbNull'
Prisma.JsonNull = 'JsonNull'
Prisma.AnyNull = 'AnyNull'

/**
 * Enums
 */
// Based on
// https://github.com/microsoft/TypeScript/issues/3192#issuecomment-261720275
function makeEnum(x) { return x; }

exports.Prisma.CompanyScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  login: 'login',
  password: 'password'
});

exports.Prisma.QuestionScalarFieldEnum = makeEnum({
  id: 'id',
  question: 'question',
  index: 'index'
});

exports.Prisma.SurveryResponseScalarFieldEnum = makeEnum({
  id: 'id',
  companyId: 'companyId',
  time: 'time'
});

exports.Prisma.SurveryResponseAnswerScalarFieldEnum = makeEnum({
  surveryResponseId: 'surveryResponseId',
  questionId: 'questionId',
  answer: 'answer'
});

exports.Prisma.KpiScalarFieldEnum = makeEnum({
  id: 'id',
  companyId: 'companyId',
  name: 'name',
  description: 'description'
});

exports.Prisma.KpiQuantitativeScalarFieldEnum = makeEnum({
  id: 'id',
  unit: 'unit',
  targetMax: 'targetMax',
  targetMin: 'targetMin',
  targetDate: 'targetDate'
});

exports.Prisma.KpiQuantitativeMeasurementScalarFieldEnum = makeEnum({
  id: 'id',
  kpiId: 'kpiId',
  value: 'value',
  time: 'time'
});

exports.Prisma.KpiQualitativeScalarFieldEnum = makeEnum({
  id: 'id'
});

exports.Prisma.KpiQualitativeEnumScalarFieldEnum = makeEnum({
  id: 'id',
  kpiId: 'kpiId',
  value: 'value'
});

exports.Prisma.KpiQualitativeMeasurementScalarFieldEnum = makeEnum({
  id: 'id',
  enumId: 'enumId',
  time: 'time'
});

exports.Prisma.SortOrder = makeEnum({
  asc: 'asc',
  desc: 'desc'
});

exports.Prisma.QueryMode = makeEnum({
  default: 'default',
  insensitive: 'insensitive'
});


exports.Prisma.ModelName = makeEnum({
  Company: 'Company',
  Question: 'Question',
  SurveryResponse: 'SurveryResponse',
  SurveryResponseAnswer: 'SurveryResponseAnswer',
  Kpi: 'Kpi',
  KpiQuantitative: 'KpiQuantitative',
  KpiQuantitativeMeasurement: 'KpiQuantitativeMeasurement',
  KpiQualitative: 'KpiQualitative',
  KpiQualitativeEnum: 'KpiQualitativeEnum',
  KpiQualitativeMeasurement: 'KpiQualitativeMeasurement'
});

/**
 * Create the Client
 */
class PrismaClient {
  constructor() {
    throw new Error(
      `PrismaClient is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
    )
  }
}
exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
